import Constants from './enums';
import { getOldEventWTS, getNotifFromDb, getLatestEventsWTS } from '../db/timelineEvents';
import { getDayStats } from '../db/stats';
import { DB, Stores } from '../db/dbschema';
const computeStats = require('../lib/geoDistCal').computeStats;

export class Listeners {
  constructor() {
    this.events = [];
    this.processedEvts = [];
    this.loc_evts = [];
    this.pseudoEvents = [];
    this.detectionStartTsMap = {};
    this.eventIndexMapping = {};
    this.reqLocForDay = {};
    this.generateEventIndexMapping()
  }

  onWsReady = (state) => {
    this.wsState = state;
  }

  SendRequest = (data) => {
    global.gWebSocket.SendRequest({ data: data });
  }

  fetchTlEvent = (data) => {
    if (data.vid) {
      getLatestEventsWTS(data.vid, (err, wts) => {
        if (err) {
          console.error("IndexedDB error " + err);
        } else {
          var req = { a: "getTimelineEvents", d: { veh: [{ vid: data.vid, wts: wts || Constants.TODAY_START_TS_IN_SEC }] } }; // wts not present then request today's tlevents
          this.latestEvents = true;
          global.gWebSocket.SendRequest({ data: req });
        }
      });
    }
  }

  onGetEvents = (params) => {
    getOldEventWTS(params.vid, (err, wts) => {
      if (err) {
        console.error("IndexedDB error " + err);
      } else {
        var data = { a: "getTlEvtByLimit", d: { vid: params.vid, wts: wts ? (wts - 1) : Math.ceil(Date.now() / 1000), count: params.limit || Constants.NOTIF_CNT } };
        let veh = (global.bikeDetails || []).find(veh => veh.idx === params.vid);
        if (veh && veh.hwtyp) data.d.hwtyp = veh.hwtyp;
        this.SendRequest(data);
      }
    })
  }

  timelineEvents = (evt) => {
    if (evt.obj && evt.obj.ts !== 0) {
      this.events.push(evt.obj);
    } else {
      if (this.events.length) {
        this.events = this.events.sort((a, b) => (a.ts || a.tsFr) - (b.ts || b.tsFr)); // all events are sorted in ascending order

        let pseudoEvents = this.events.filter((e) => {
          return e.t === Constants.NOTIF_TYPE.PSEUDO_EVT;
        })
        if (pseudoEvents && pseudoEvents.length) {
          this.processPseudoEvents();
        }
        else {
          this.processedEvts = [...this.events];
          var todaysEvts;
          if (this.processedEvts.length) todaysEvts = this._checkForTodaysEvents(this.processedEvts);
          if (todaysEvts) {
            this._getTodaysLocEvts(this.processedEvts[0].vid);
            this.today_loc = true;
          } else global.EE.emitEvent(global.EE.EVENT_TYPES.PSEUDO_PROCESSED, true);
        }
      } else {
        global.EE.emitEvent(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, { processedEvts: this.events, tlEvents: this.events });
        this.events = [];
        this.processedEvts = [];
      }
    }
  }

  _checkForTodaysEvents = (evts) => {
    if ((evts[0].ts >= Constants.TODAY_START_TS_IN_SEC) && (evts[0].ts <= Constants.TODAY_END_TS_IN_SEC) && (evts[evts.length - 1].ts >= Constants.TODAY_START_TS_IN_SEC) && (evts[evts.length - 1].ts <= Constants.TODAY_END_TS_IN_SEC)) return true;
    else return false;
  }

  _getTodaysLocEvts = (vid) => {
    let fromTs, toTs;
    fromTs = Constants.TODAY_START_TS_IN_SEC;
    toTs = Math.round(Date.now() / 1000);
    this.getLocationEvents(vid, fromTs, toTs);
  }

  processPseudoEvents = () => {
    this.pseudoEvents = [];
    if (this.events.length) {
      this.events.forEach((e, i) => { // all events are sorted in ascending order
        if (e.t === Constants.NOTIF_TYPE.PSEUDO_EVT) {
          let pseudoEvtObj = {};

          if (this.events[i - 1]) {
            if (this.events[i - 1].t !== Constants.NOTIF_TYPE.PSEUDO_EVT) {
              pseudoEvtObj.pseudoEvt = e;
              pseudoEvtObj.prevEvt = this.events[i - 1];
            }
          } else pseudoEvtObj.pseudoEvt = e;

          if (this.events[i + 1]) {
            if (this.events[i + 1].t !== Constants.NOTIF_TYPE.PSEUDO_EVT) {
              pseudoEvtObj.nextEvt = this.events[i + 1];
            }
            else { //If next event of pseudo event is also a pseudo event then need to find the next timeline event and store it as next event.
              let pseudoNxtEvtIndex = this.events.findIndex((e, index) => (index >= i && e.t !== Constants.NOTIF_TYPE.PSEUDO_EVT));
              if (pseudoEvtObj.pseudoEvt) {
                if (pseudoNxtEvtIndex >= 0) { // Next timeline event is present then store it as nextEvt
                  pseudoEvtObj.nextEvt = this.events[pseudoNxtEvtIndex];
                } else {
                  /**
                   *  If next timeline event is not present and have more than one pseudo events in a sequence then change toTs of pseudo.
                   *  tots will be the last pseudo events's toTs.
                   */
                  let lastPseudo = this.events.filter((e, index) => (index >= i && e.t === Constants.NOTIF_TYPE.PSEUDO_EVT));
                  lastPseudo = lastPseudo.sort((a, b) => (b.tsFr - a.tsFr));
                  pseudoEvtObj.pseudoEvt['tsTo'] = lastPseudo[0].tsTo;
                  pseudoEvtObj.needNxtEvt = true;
                }
              }
            }
          } else {
            /**
             * If last event is pseudo then fetch next event
             */
            pseudoEvtObj.needNxtEvt = true;
          }

          if (pseudoEvtObj.pseudoEvt) {
            this.pseudoEvents.push(pseudoEvtObj);
          }
        } else {
          if (!this.events[i - 1] || (this.events[i - 1] && this.events[i - 1].t !== Constants.NOTIF_TYPE.PSEUDO_EVT)) {
            /**
             * Push all the events in the processed events array if previous events is not a pseudo event.
             * Next event after a pseudo event will be added to processed events array after processing of pseudo.
             */

            this.processedEvts.push(e);
          }
        }
      });

      if (this.pseudoEvents.length) {
        var needNxtEvtIndex = this.pseudoEvents.findIndex(p => p.needNxtEvt);
        if (needNxtEvtIndex >= 0) {
          this._getNextTimelineEvent(this.pseudoEvents[needNxtEvtIndex].pseudoEvt, (err, evt) => {
            if (err) console.error(err);
            else if (evt) this.pseudoEvents[needNxtEvtIndex].nextEvt = evt;
            this.pseudoIndex = 0;
            this.getLocForPseudo(this.pseudoEvents);
          });
        } else {
          this.pseudoIndex = 0;
          this.getLocForPseudo(this.pseudoEvents);
        }
      } else this.saveEvents();
    }
  }

  _getNextTimelineEvent(evt, cb) {
    let params = { vids: [evt.vid], fromTs: evt.ts || evt.wts, count: 1, sort: 'asc' };
    getNotifFromDb(params, (err, notif) => {
      if (err) cb(err);
      else {
        if (notif.length) cb(null, notif[0]);
        else cb(null);
      }
    });
  }

  getLocForPseudo = () => {
    let vid, fromTs, toTs;
    vid = this.pseudoEvents[this.pseudoIndex].pseudoEvt.vid;
    fromTs = this.pseudoEvents[this.pseudoIndex].prevEvt ? this.pseudoEvents[this.pseudoIndex].prevEvt.ts : (this.pseudoEvents[this.pseudoIndex].pseudoEvt.tsFr - 1);
    toTs = this.pseudoEvents[this.pseudoIndex].nextEvt ? this.pseudoEvents[this.pseudoIndex].nextEvt.ts : this.pseudoEvents[this.pseudoIndex].pseudoEvt.tsTo;
    this.getLocationEvents(vid, fromTs, toTs);
  }

  getLocationEvents = (vid, fromTs, toTs) => {
    var data = { vid, fromTs, toTs };
    this.SendRequest({ a: "getLocEvents", d: data });
  }

  checkEventsForTruth(typeListToCheck) {
    let validEvents = [];
    if (typeListToCheck.length > 1) {
      for (var i = 0; i < (typeListToCheck.length - 1); i++) {
        var ret = this.checkMatrix(typeListToCheck[i].t, typeListToCheck[i + 1].t);
        if (ret) validEvents.push(typeListToCheck[i + 1]);
      }
    }
    return validEvents;
  }

  generateEventIndexMapping() {
    for (var i = 0; i < Constants.NOTIF_TYPES_ARRAY.length; i++) {
      var currField = Constants.NOTIF_TYPES_ARRAY[i];
      this.eventIndexMapping[currField] = i;
    }
  }

  checkMatrix(prevType, currType) {
    var prevIndex = this.eventIndexMapping[prevType];
    var currIndex = this.eventIndexMapping[currType];
    if (prevIndex == null || currIndex == null) return true;
    return Constants.EVENT_CHECK_MATRIX[prevIndex][currIndex];
  }

  eventsGenerator(locEvents) {
    var eventsFromPseudo = [];

    for (let i = 1; i < (locEvents.length - 1); i++) {
      let evntTypeArr = [];
      evntTypeArr = this.checkForEvents(locEvents[i - 1], locEvents[i]);

      if (evntTypeArr.length) {
        evntTypeArr.forEach((e, j) => {
          e.lat = locEvents[i].lat || null;
          e.lng = locEvents[i].lng || null;
          e.ts = (locEvents[i].ts + j);   // need to add one seconds if multiple events occure at the same time
          e.wts = (locEvents[i].ts + j);
          e.vid = locEvents[i].vid;
        });
        eventsFromPseudo.push.apply(eventsFromPseudo, evntTypeArr);
      }
    }
    return eventsFromPseudo;
  }

  onLocationEvents = (loc) => {
    if (loc.obj.ts !== 0) {
      this.loc_evts.push(loc.obj);
    } else {
      if (this.loc_evts) {
        if (this.today_loc) {
          var today_loc = [...this.loc_evts];
          this._computeStatsForLoc(today_loc, () => {
            if (this.processedEvts.length) global.EE.emitEvent(global.EE.EVENT_TYPES.PSEUDO_PROCESSED, true);
            this.today_loc = false;
            this.loc_evts = [];
          });
        } else {
          this.loc_evts = this.loc_evts.sort((a, b) => a.ts - b.ts);

          if (this.dailyLoc) {
            this.storeLocInDailyStats(this.loc_evts);
            this.loc_evts = [];
          } else { // Pseudo event's location processing
            if (this.loc_evts.length) {
              var events = this.eventsGenerator(this.loc_evts);
              if (events.length) {
                if (this.pseudoEvents[this.pseudoIndex].prevEvt) events.unshift(this.pseudoEvents[this.pseudoIndex].prevEvt);
                if (this.pseudoEvents[this.pseudoIndex].nextEvt && !this.pseudoEvents[this.pseudoIndex].needNxtEvt) events.push(this.pseudoEvents[this.pseudoIndex].nextEvt);
                let validEvents = this.checkEventsForTruth(events);
                if (validEvents.length) {
                  this.processedEvts.push.apply(this.processedEvts, validEvents);
                }
              } else {
                if (this.pseudoEvents[this.pseudoIndex] && this.pseudoEvents[this.pseudoIndex].nextEvt) {
                  this.processedEvts.push(this.pseudoEvents[this.pseudoIndex].nextEvt);
                }
              }
            }

            this.loc_evts = [];
            this.pseudoIndex += 1;
            if (this.pseudoEvents && this.pseudoEvents[this.pseudoIndex]) this.getLocForPseudo();

            if (this.pseudoEvents && this.pseudoEvents.length && (this.pseudoIndex === this.pseudoEvents.length)) {
              var todaysEvts;
              if (this.processedEvts.length) todaysEvts = this._checkForTodaysEvents(this.processedEvts);
              if (todaysEvts) {
                this._getTodaysLocEvts(this.processedEvts[0].vid);
                this.today_loc = true;
              } else {
                global.EE.emitEvent(global.EE.EVENT_TYPES.PSEUDO_PROCESSED, true);
              }
            }
          }
        }
      }
    }
  }

  _storeLocEvtInTlEvnts = (locEvts, processedEvts) => {
    processedEvts.forEach((e, i) => {
      let toTs = null;
      if (processedEvts[i + 1]) toTs = (processedEvts[i + 1].ts);
      let loc_evts = this._getLocEvtsByTs(locEvts, e.ts, toTs);
      if (loc_evts && loc_evts.length) e.loc = loc_evts;
    });
    global.EE.emitEvent(global.EE.EVENT_TYPES.PSEUDO_PROCESSED, true);
  }

  _getLocEvtsByTs(locEvts, from, to) {
    let filterLoc = locEvts.filter(le => to ? (le.ts >= from && le.ts < to) : le.ts >= from);
    return filterLoc;
  }

  checkForEvents = (prevLocEvt, currentLocEvt) => {
    let evtsArr = [];

    //check for ignition
    if (prevLocEvt.ignition && !currentLocEvt.ignition)
      evtsArr.push({ t: Constants.NOTIF_TYPE.IGNITION_OFF });
    else if (!prevLocEvt.ignition && currentLocEvt.ignition)
      evtsArr.push({ t: Constants.NOTIF_TYPE.IGNITION_ON });

    // check for motion and vibration
    if ((prevLocEvt.motion && currentLocEvt.motion) && (!prevLocEvt.ignition && !currentLocEvt.ignition)) {
      if (currentLocEvt.speed > Constants.MOTION_GEN_SPEED_THRESH) {
        let mdts = this.detectionStartTsMap[Constants.NOTIF_TYPE.MOTION];
        if (mdts == null)
          this.detectionStartTsMap[Constants.NOTIF_TYPE.MOTION] = currentLocEvt.ts;
        else if ((currentLocEvt.ts - mdts) >= Constants.MOTION_GEN_TIME_THRESH)
          evtsArr.push({ t: Constants.NOTIF_TYPE.MOTION })
      } else {
        let vdts = this.detectionStartTsMap[Constants.NOTIF_TYPE.VIBRATION];
        if (vdts == null)
          this.detectionStartTsMap[Constants.NOTIF_TYPE.VIBRATION] = currentLocEvt.ts;
        else if ((currentLocEvt.ts - vdts) >= Constants.VIBRATION_GEN_TIME_THRESH)
          evtsArr.push({ t: Constants.NOTIF_TYPE.VIBRATION })
      }
    }

    //check for main-power
    if (!prevLocEvt.mainPower && currentLocEvt.mainPower)
      evtsArr.push({ t: Constants.NOTIF_TYPE.POWER_ON });
    else if (prevLocEvt.mainPower && !currentLocEvt.mainPower)
      evtsArr.push({ t: Constants.NOTIF_TYPE.POWER_OFF });

    //check for relay
    if (!prevLocEvt.relayState && currentLocEvt.relayState)
      evtsArr.push({ t: Constants.NOTIF_TYPE.RELAY_OFF });
    else if (prevLocEvt.relayState && !currentLocEvt.relayState)
      evtsArr.push({ t: Constants.NOTIF_TYPE.RELAY_ON });

    return evtsArr;
  }

  saveEvents = () => {
    let evLen = this.events.length;
    if (this.events.length) {
      this.events = this.events.sort((a, b) => b.wts - a.wts); // Sort in descending order
      global.indexedDbClient.getValueByKey(DB.GL, Stores.LatestEventsWts, this.events[0].vid)
        .then((wts) => {
          if (!wts) wts = 0;
          if (wts < this.events[0].wts) {
            return global.indexedDbClient.addSingleRecord(DB.GL, Stores.LatestEventsWts, { key: this.events[0].vid, value: this.events[0].wts });
          } else return Promise.resolve();
        })
        .then(() => {
          return global.indexedDbClient.getValueByKey(DB.GL, Stores.OldEventsWts, this.events[0].vid);
        })
        .then((oldwts) => {
          if ((oldwts > this.events[evLen - 1].wts) || !oldwts) {
            return global.indexedDbClient.addSingleRecord(DB.GL, Stores.OldEventsWts, { key: this.events[0].vid, value: this.events[evLen - 1].wts });
          } else return Promise.resolve();
        })
        .then(() => {
          if (this.processedEvts && this.processedEvts.length) {
            return global.indexedDbClient.addMultipleRecords(DB.GL, this.processedEvts[0].vid + Stores._TimelineEvents, this.processedEvts)
          } else return Promise.resolve();
        })
        .then(() => {
          if (this.processedEvts && this.processedEvts.length) {
            global.EE.emitEvent(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, { processedEvts: this.processedEvts, tlEvents: this.events });
          } else this.onGetEvents({ vid: this.events[0].vid });
          this.events = [];
          this.processedEvts = [];
        })
        .catch((e) => {
          console.error("IndexedDB error " + e);
          global.EE.emitEvent(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, { processedEvts: this.processedEvts, tlEvents: this.events });
          this.events = [];
          this.processedEvts = [];
        })
    } else {
      global.EE.emitEvent(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, { processedEvts: this.processedEvts, tlEvents: this.events });
      this.events = [];
      this.processedEvts = [];
    }
  }

  _computeStatsForLoc = (locEvts, cb) => {
    if (locEvts.length) {
      var stats = computeStats(locEvts.sort((a, b) => a.ts - b.ts), true);
      if (stats && stats.dst) {
        stats.vid = locEvts[0].vid;
        stats.ts = new Date(locEvts[0].ts * 1000).setHours(0, 0, 0, 0);
        stats.dur = stats.edt - stats.sdt;
        if (stats.ignOnDur && stats.dst) stats.avs = ((stats.dst / stats.ignOnDur) * (18 / 5)) || 0;
        stats.mdt = Math.floor(Date.now() / 1000);
        stats.loc = locEvts.filter(loc => ( loc.lat && loc.lng && (loc.ignition || (loc.motion && loc.spd > Constants.MOTION_SPEED_THRESH))));
        global.indexedDbClient.addSingleRecord(DB.GL, stats.vid + Stores._DailyStats, stats, true)
          .then(() => {
            return global.indexedDbClient.addSingleRecord(DB.GL, Stores.LatestDailyStatsMdt, { key: stats.vid, value: stats.mdt });
          })
          .then(() => {
            cb(null, stats);
          })
          .catch((e) => {
            console.error("IndexedDB error while storing todays stats " + e);
            cb(null, stats);
          })
      } else cb(null, stats);
    } else {
      console.error("Provide location array for computing stats");
      cb("Provide location array for computing stats");
    }
  }

  getLocForDay = (data) => {
    if (data.vid && data.ts) {
      let to_ts = (new Date(data.ts).setHours(23, 59, 59));
      let validToTs = to_ts > Date.now() ? Date.now() : to_ts;
      let toTs = Math.trunc(validToTs / 1000);
      this.dailyLoc = true;
      this.reqLocForDay = { vid: data.vid, ts: data.ts };
      let ts_sec = Math.trunc(data.ts / 1000);
      this.getLocationEvents(data.vid, ts_sec, toTs);
    }
    else console.error("Vehicle id or day start ts is missing while getting location pings");

  }

  storeLocInDailyStats = (locEvts) => {
    let ionLocEvts = locEvts.filter(loc => (loc.lat && loc.lng && (loc.ignition || (loc.motion && loc.spd > Constants.MOTION_SPEED_THRESH))));
    getDayStats(this.reqLocForDay.vid, this.reqLocForDay.ts, (err, data) => {
      if (err) {
        console.error("Error while storing location sin stats" + err);
      } else {
        if (data) {
          data.loc = ionLocEvts;
          global.indexedDbClient.addSingleRecord(DB.GL, (this.reqLocForDay.vid + Stores._DailyStats), data, true) // Fouth parameter for update
            .then(() => {
              global.EE.emitEvent(global.EE.EVENT_TYPES.SAVED_LOC_FOR_DAY, data);
            })
            .catch((e) => {
              global.EE.emitEvent(global.EE.EVENT_TYPES.SAVED_LOC_FOR_DAY, data);
              console.error("IndexedDB error while updating location pings in stats " + e);
            })
        } else {
          this._computeStatsForLoc(locEvts, (err, stats) => {
            if(stats) global.EE.emitEvent(global.EE.EVENT_TYPES.SAVED_LOC_FOR_DAY, stats);
          });
        }
      }
    })
  }
}